import PortfolioTabContainer from "../containers/portfolio_tab_container"

export default function Portfolio() {
    return <PortfolioTabContainer />
}
